import { render, staticRenderFns } from "./Frdjz.vue?vue&type=template&id=1729c104&scoped=true&"
import script from "./Frdjz.vue?vue&type=script&lang=js&"
export * from "./Frdjz.vue?vue&type=script&lang=js&"
import style0 from "./Frdjz.vue?vue&type=style&index=0&id=1729c104&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1729c104",
  null
  
)

export default component.exports